import * as React from "react"
import { useEffect } from 'react'

import { Box } from '@mui/material'
import { CommonFilters } from '@components'
import {COMMON_FILTER_KEYS, DIGITAL_SHELF_ROUTES} from '@constants'
import { CUSTOM_DASHBOARD_ROUTES } from '@constants/routes'
import { useAppDefaultFilters } from '@hooks'
import {isLoadingCommonFilters, isSystemBusy} from '@signals'
import {isEmptyAmazonReleaseDate} from "./@signals";


export default function AmazonReleaseDateFilters() {
    const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(CUSTOM_DASHBOARD_ROUTES.AMAZON_RELEASE_DATE_ID, CUSTOM_DASHBOARD_ROUTES.ID)

    useEffect(() => {
        callUserDefaultFilters()
    }, [])

    return <Box data-tour="amazon-release-date-filters">
    <CommonFilters
        components={{
            country: true, site: true,
            category: true, brand: true,
            sku: true, favFilters: true,
            favFiltersOnlyLine: true, skuGroup: true
        }}
        compProps={{
            country: { grid: { md: 4 }, filters: { websiteType: "2" } },
            site: { grid: { md: 4 }, filters: { websiteType: "2" } },
            sku: { grid: { md: 4 } },
            skuGroup: { grid: { md: 4 } },
            category: { grid: { md: 4 } },
            favFiltersOnlyLine: { grid: { md: 10 } },
            brand: { grid: { md: 4 } },
            favFilters: {
                allowedFilters: [
                    COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
                    COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU
                ],
                dashboardKey: CUSTOM_DASHBOARD_ROUTES.AMAZON_RELEASE_DATE_ID
            }
        }}
        onSubmit={() => {
            isSystemBusy.value = false
            isLoadingCommonFilters.value = true
            isEmptyAmazonReleaseDate.value = false
        }}
        defaultValues={userFilters}
        isLoadingDefaultFilters={isLoadingDefaultFilters}
    />
    </Box>
}
